/* NewsletterSignupV2 */
import { FunctionalComponent, h, Host } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import NewsletterSignupV2InitialTemplate from './cwc-newsletter-signup-v2-initial.template';
import NewsletterSignupV2SuccessfulTemplate from './cwc-newsletter-signup-v2-successful.template';
import NewsletterSignupV2FailedTemplate from './cwc-newsletter-signup-v2-failed.template';
import { SignUpState } from '../types/signup-state.enum';
import { NewsletterSignupV2Component } from '../newsletter-signup-v2';

/**
 * Definition of  parameters that the template needs to work.
 */
interface NewsletterSignupV2TemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: NewsletterSignupV2Component;
  // Specify parameters that are required to be passed down to the template here.
}

const NewsletterSignupV2Template: FunctionalComponent<NewsletterSignupV2TemplateProps> = ({ controller }) => (
  <Host sign-up-state={controller.signUpState}>
    <cwc-newsletter-signup-container>
      {controller.signUpState == SignUpState.INITIAL || controller.signUpState == SignUpState.LOAD ? (
        <NewsletterSignupV2InitialTemplate controller={controller} />
      ) : (
        ''
      )}
      {controller.signUpState == SignUpState.SUCCESSFUL ? (
        <NewsletterSignupV2SuccessfulTemplate controller={controller} />
      ) : (
        ''
      )}
      {controller.signUpState == SignUpState.FAILED ? <NewsletterSignupV2FailedTemplate controller={controller} /> : ''}
    </cwc-newsletter-signup-container>
  </Host>
);

export default NewsletterSignupV2Template;
